export const GITHUB_BUG_REPORT = {
  headline: '#512 triaged · S2, suggested owner Kabir',
  status: 'done',
  durationSec: 57,
  body: `**Issue #512 — “Schedule panel shows the wrong next run after changing timezone”**

- **Severity:** S2 — wrong information shown, no data loss.
- **Likely cause:** the next run is recomputed in the browser’s timezone rather than the schedule’s.
- **Similar:** #488 (closed) fixed the same bug for the list view only.
- **Suggested owner:** Kabir — last changed the schedule details panel.

**Repro from the report**

1. Open a schedule set to 10:00 Asia/Kolkata.
2. Change the timezone to Europe/London and save.
3. The panel still shows the old next-run time until the page reloads.

Posted to #eng-triage.`,
}
